// extracted by mini-css-extract-plugin
module.exports = {"textBtn":"TextButton_textBtn__1aF7Q"};